import { createRouter, createWebHistory } from 'vue-router';
import { accountRoutes } from '@/js/account/app/router/routes';

export const router = createRouter({
  history: createWebHistory(),
  routes: accountRoutes,
  scrollBehavior: () => ({ top: 0 }),
});
